var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppHeaderDropdown",
    { staticClass: "pr-2", attrs: { right: "" } },
    [
      _c("template", { slot: "header" }, [
        _c("img", {
          staticClass: "img-avatar",
          attrs: { src: _vm.avatarUrl, alt: _vm.name },
        }),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "dropdown" },
        [
          _c("b-dropdown-item", { on: { click: _vm.handleProfile } }, [
            _c("i", { staticClass: "fas fa-user" }),
            _vm._v(" " + _vm._s(_vm.$t("nav.my_profile")) + "\n        "),
          ]),
          _vm._v(" "),
          _c("b-dropdown-item", { on: { click: _vm.handleTariff } }, [
            _c("i", { staticClass: "fas fa-dollar-sign" }),
            _vm._v(" " + _vm._s(_vm.$t("nav.tariff")) + "\n        "),
          ]),
          _vm._v(" "),
          _c("b-dropdown-item", { on: { click: _vm.handleTeams } }, [
            _c("i", { staticClass: "fas fa-users" }),
            _vm._v(" " + _vm._s(_vm.$t("nav.teams"))),
          ]),
          _vm._v(" "),
          _c("b-dropdown-item", { on: { click: _vm.handleSubscriptions } }, [
            _c("i", { staticClass: "fas fa-calculator" }),
            _vm._v(" " + _vm._s(_vm.$t("nav.subscriptions")) + "\n        "),
          ]),
          _vm._v(" "),
          _vm.isAdmin
            ? _c("b-dropdown-item", { on: { click: _vm.handlePayments } }, [
                _c("i", { staticClass: "fas fa-donate" }),
                _vm._v(" " + _vm._s(_vm.$t("nav.payments")) + "\n        "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("b-dropdown-item", { on: { click: _vm.handleInvoices } }, [
            _c("i", { staticClass: "fas fa-file-invoice-dollar" }),
            _vm._v(" " + _vm._s(_vm.$t("nav.invoices")) + "\n        "),
          ]),
          _vm._v(" "),
          _c("b-dropdown-divider"),
          _vm._v(" "),
          _c("b-dropdown-item", { on: { click: _vm.handleLogout } }, [
            _c("i", { staticClass: "fas fa-lock" }),
            _vm._v(" " + _vm._s(_vm.$t("nav.logout"))),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }